<div class="flex flex-col max-w-300 md:min-w-200 max-h-screen -m-6">
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{dialogTitle}}</div>
    <button mat-icon-button (click)="onClose()" [tabIndex]="-1">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>

  <div class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
    <div style="text-align: end;position: sticky;" class="mb-2">

      <button class="ml-4 mt-3 mb-2" mat-flat-button [color]="'primary'" (click)="addColumn()">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Add Plot</span>
      </button>
    </div>

    <div class="table-container max-w-250" style="overflow-y: auto; max-height: 430px;">

      <table mat-table [dataSource]="dataSource">

        <!-- Fixed Row Column -->
        <ng-container matColumnDef="rowName">
          <th mat-header-cell *matHeaderCellDef> - </th>
          <td mat-cell *matCellDef="let element"> {{element.rowName}} </td>
        </ng-container>

        <!-- Dynamic Columns -->
        <ng-container *ngFor="let column of displayedColumns.slice(1)">
          <ng-container matColumnDef="{{column}}">
            <th mat-header-cell *matHeaderCellDef style="text-align:center;">
              <mat-form-field *ngIf="editingColumnName === column">
                <input matInput [value]="column" (blur)="updateColumnName(column, $event)"
                  placeholder="Edit column name">
              </mat-form-field>
              <span *ngIf="editingColumnName !== column" (click)="startEditingColumn(column)">
                {{column}}
                <div *ngIf="displayedColumns.length!==2">
                <button mat-icon-button (click)="removePlotColumn(column)" >
                  <mat-icon class="icon-size-4">delete_forever</mat-icon>
                </button>
              </div>
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-form-field class="w-full md:w-10/3 px-3" appearance="outline">
                <input matInput [(ngModel)]="element[column]" placeholder="Enter value">
              </mat-form-field>
            </td>
          </ng-container>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>

        <!-- Data Row -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

    </div>

    <div style="text-align: end;" class="mb-2">
      <button class="ml-4 mt-3 mb-2" mat-flat-button [color]="'primary'" (click)="saveReportBoundries()">
        <span class="ml-2 mr-1">Save</span>
      </button>
    </div>

  </div>

</div>